<template>
  <div class="choose-evidence">
    <div class="fraud-guide-title">请选择举报原因</div>
     <!-- 单选框-勾选证据 -->
    <div class="reason-scroll">
      <div class="reason-title">请勾选最能体现对方在转转内的违规证据</div>
      <RadioGroup class="reason-radiolist" v-model="evidence">
        <Radio
          class="reason-radioitem"
          :name="1"
          @click="radioevidenceClick(1)"
          v-if="evidenceChoose.indexOf('1') > -1"
          >商品</Radio
        >
        <Radio
          class="reason-radioitem"
          :name="2"
          @click="radioevidenceClick(2)"
          v-if="evidenceChoose.indexOf('2') > -1"
          >私信</Radio
        >
        <Radio
          class="reason-radioitem"
          :name="3"
          @click="radioevidenceClick(3)"
          v-if="evidenceChoose.indexOf('3') > -1"
          >订单<span :style="{ color: 'red' }">（如有订单，建议优先选择）</span></Radio
        >
        <Radio
          class="reason-radioitem"
          :name="4"
          @click="radioevidenceClick(4)"
          v-if="evidenceChoose.indexOf('4') > -1"
          >其他<span>（如昵称、头像、留言等）</span></Radio
        >
      </RadioGroup>
      <!-- 勾选其他证据的输入框 -->
      <div v-if="isShowotherEvidence">
        <section class="process-evidence">
          <input
            id="desc"
            v-model="otherEvidence"
            placeholder="请输入对方的违规证据"
            maxlength="15"
            @focus="intoInputEvidenceView"
            @blur="txtBoxBlur"
            ref="inputEvidence"
          />
          <span class="desc-length">{{ remainDescLength }}</span>
        </section>
      </div>
    </div>
    <Popup @closed="closeModal" v-model="showModal" position="bottom">
      <!-- 商品列表下拉框 -->
      <product-list
        @close="closeModal"
        v-if="infoVisible"
        @selected="goodsSelected"
        :beReportedUid="beReportedUid"
        :defaultSelect="this.sharedData.infoId"
      ></product-list>
      <!-- 私信列表 -->
      <letter-list
        @close="closeModal"
        v-if="letterVisible"
        @selected="letterSelected"
        :beReportedUid="beReportedUid"
      ></letter-list>
      <!-- 订单列表 -->
      <order-list
        @close="closeModal"
        v-if="orderVisible"
        @selected="orderSelected"
        :beReportedUid="beReportedUid"
      ></order-list>
    </Popup>

    <!-- 下一步 -->
    <z-button-group v-if="isShowotherEvidence">
      <z-button type="primary"  @click="otherSelected">下一步</z-button>
    </z-button-group>
  </div>
</template>

<script>
import ProductList from '../ProductList/index.vue'
import OrderList from '../OrderList/index.vue'
import LetterList from '../LetterList/index.vue'
import { Radio, RadioGroup, Popup, Button, ButtonGroup } from '@zz-common/zz-ui'

const MAX_DESC_LENGTH = 15

export default {
  name: 'ChooseEvidence',
  components: {
    Radio,
    RadioGroup,
    Popup,
    zButton: Button,
    zButtonGroup: ButtonGroup,
    ProductList,
    OrderList,
    LetterList
  },
  inject: ['sharedData', 'submitData', 'mergeSubmitData', 'radioChooseEvidence'],
  // inject:
  // {
  //   sharedData: {
  //     default: () => {}
  //   },
  //   submitData: {
  //     default: () => {}
  //   },
  //   mergeSubmitData: {}
  // },
  data() {
    return {
      showModal: false, //勾选证据弹窗
      evidence: '', //选择原因的证据
      infoVisible: false, //商品显隐
      orderVisible: false, //订单显隐
      letterVisible: false, //私信显隐
      isShowotherEvidence: false, //其他证据显隐
      otherEvidence: '' //其他证据留言
    }
  },
  computed: {
    //剩余长度
    remainDescLength() {
      return this.otherEvidence.length + '/' + MAX_DESC_LENGTH
    },
    evidenceChoose() {
      console.log('触发响应式radioevidence', this.radioChooseEvidence())
      return this.radioChooseEvidence()
    },
    //对方uid
    beReportedUid() {
      return this.sharedData.toUid
    }
  },
  methods: {
    //勾选证据单选框
    radioevidenceClick(reasonId) {
      if (reasonId === 4) {
        this.isShowotherEvidence = true
        return
      }
      this.isShowotherEvidence = false
      this.showModal = true
      this.showinfo(reasonId)
    },
    //控制3个下拉框的展示
    showinfo(reasonId) {
      this.infoVisible = false
      this.orderVisible = false
      this.letterVisible = false
      if (reasonId === 1) this.infoVisible = true
      if (reasonId === 2) this.letterVisible = true
      if (reasonId === 3) this.orderVisible = true
    },
    //关闭弹框
    closeModal() {
      this.showModal = false
      this.infoVisible = false
      this.orderVisible = false
      this.letterVisible = false
      this.evidence = ''
    },
    //焦点处理
    intoInputEvidenceView() {
      setTimeout(() => {
        this.$refs.inputEvidence.scrollIntoView()
      }, 300)
    },
    //焦点处理
    txtBoxBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
    },
    //三个列表的选择
    goodsSelected(item) {
      if (item && item.length) {
        this.goToReportSubmit(item.join(','), '1')
      }
    },
    letterSelected(item) {
      if (item && item.length) {
        this.goToReportSubmit(item.join(','), '2')
      }
    },
    orderSelected(item) {
      if (item && item.length) {
        this.goToReportSubmit(item.join(','), '3')
      }
    },
    //合并提交数据，下一步
    goToReportSubmit(chooseEvidence, chooseType) {
      console.log('提交的chooseevidence', chooseEvidence)
      this.mergeSubmitData({
        chooseEvidence,
        chooseType
      })
      this.$router.push('/reportreason/commit')
    },
    //其他选择
    otherSelected() {
      if (this.otherEvidence === '') {
        return this.$toast('请填写相关信息')
      }
      this.goToReportSubmit(this.otherEvidence, '4')
    }
  },
  activated() {
    console.log('chooseevidence激活')
    this.showModal = false
    this.infoVisible = false
    this.letterVisible = false
    this.orderVisible = false
    this.evidence = ''
    this.isShowotherEvidence = false
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>